import React, { useMemo } from 'react';
import { IProduct } from '@/models';
import { useRouter } from 'next/router';
import { getLangCountry } from '@/helpers/languages';

interface Props {
  product: IProduct;
}

const FeedatyVerticalReviews: React.FC<Props> = ({ product }) => {
  const router = useRouter();
  const { lang } = getLangCountry(router.query);

  const dataGui = useMemo(() => {
    let dataGui = 'all';

    switch (lang.toLowerCase()) {
      case 'it':
        dataGui = 'it-IT';
        break;
      case 'de':
        dataGui = 'de-DE';
        break;
      case 'fr':
        dataGui = 'fr-FR';
        break;
      case 'es':
        dataGui = 'es-ES';
        break;
      case 'en':
      default:
        dataGui = 'en-US';
        break;
    }

    return dataGui;
  }, [lang]);

  return (
    <section className="section full">
      <div
        className="feedaty_widget css-feedaty_widget-vertical-reviews px-6 md:px-10 xl:px-16 "
        data-ver="2021"
        data-id="65801272d7a50"
        data-type="product_tab"
        data-variant="Recensioni-Verticale-40-60"
        data-lang="all"
        data-gui={dataGui}
        data-sku={product.selling_code}
        data-snippets="0"
      ></div>
    </section>
  );
};

export default FeedatyVerticalReviews;
